__turbopack_context__.v({
  "antall": "ResultatWrapper-module__YMNKQa__antall",
  "filterRad": "ResultatWrapper-module__YMNKQa__filterRad",
  "searchField": "ResultatWrapper-module__YMNKQa__searchField",
  "statusFilter": "ResultatWrapper-module__YMNKQa__statusFilter",
});
